import { ChangeDetectionStrategy, Component, ViewEncapsulation, input } from '@angular/core';
import { FloatLabelModule } from 'primeng/floatlabel';

@Component({
    selector: 'fcp-float-label',
    imports: [FloatLabelModule],
    styleUrl: './fcp-float-label.component.less',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <p-floatlabel [variant]="variant()" [class.ng-invalid]="invalid()" [class.ng-dirty]="invalid()">
            <ng-content />
        </p-floatlabel>
    `
})
export class FcpFloatLabelComponent {
    // Keeping variant input for backwards compatibility since the only desired variant is 'in' (default).
    variant = input<FloatLabelVariant>(FloatLabelVariant.In);
    invalid = input<boolean>(false);
}

export enum FloatLabelVariant {
    Over = 'over',
    In = 'in',
    On = 'on'
}
